var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceivablesFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receivables_Fill",
    "data-name": "CarrierPayment Fill",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "money_1_",
    "data-name": "money (1)",
    transform: "translate(82 231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M187.8,182a5.8,5.8,0,1,0,5.8,5.8A5.807,5.807,0,0,0,187.8,182Zm0,5.273a1.578,1.578,0,0,1,.527,3.067v1.152h-1.055V190.34a1.58,1.58,0,0,1-1.055-1.485h1.055a.527.527,0,1,0,.527-.527,1.578,1.578,0,0,1-.527-3.067v-1.152h1.055v1.152a1.58,1.58,0,0,1,1.055,1.485h-1.055a.527.527,0,1,0-.527.527Z",
    transform: "translate(-175.602 -175.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M5.871,6.4c3.253,0,5.8-1.39,5.8-3.164S9.124,0,5.871,0,0,1.46,0,3.234,2.618,6.4,5.871,6.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    d: "M0,337.559v.859c0,1.774,2.618,3.164,5.871,3.164.185,0,.363-.017.545-.026a6.811,6.811,0,0,1-.884-2.1A8.4,8.4,0,0,1,0,337.559Z",
    transform: "translate(0 -325.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    "data-name": "Path 3224",
    d: "M5.369,251.555c-.012-.166-.025-.332-.025-.5a6.826,6.826,0,0,1,.195-1.594A8.408,8.408,0,0,1,0,247.559v.859C0,250.1,2.365,251.419,5.369,251.555Z",
    transform: "translate(0 -238.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    "data-name": "Path 3225",
    d: "M5.871,161.582h0a6.879,6.879,0,0,1,1.481-2.208,11.768,11.768,0,0,1-1.483.1A8.577,8.577,0,0,1,0,157.559v.859C0,160.192,2.618,161.582,5.871,161.582Z",
    transform: "translate(0 -152.02)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivablesFill);
export default __webpack_public_path__ + "static/media/receivablesFill.652946412411746047682bc11469178f.svg";
export { ForwardRef as ReactComponent };